export const env = {
  // apiHost: "http://localhost:8084/",
  // frontUrl: "http://localhost:3000/",
  apiHost: "https://assetly.blfdemo.online:8084/",
  frontUrl: "https://assetly.blfdemo.online/",
  upload_preset: "capitalexc",
  cloud_name: "daipuhrqy",
  RECAPTCHA_KEY: "6LeowtkrAAAAAEKxG27dI2hMctRnJbpLKuo0HUiQ",
  SITE_URL: "http://localhost:3000/",
};
